<script>
import { BTooltip } from 'bootstrap-vue';

export default {
  components: {
    BTooltip,
  },

  props: {
    pages: {
      requred: true,
      default: null,
    },

    form: {
      required: true,
      default: null,
    },
  },

  data: () => ({
    delay: {
      show: 50,
      hide: 100,
    },
  }),
};
</script>

<template>
  <div
    class="form__badge"
    :id="`badge-${form}`"
  >
    {{ pages.length }}
    <BTooltip
      :delay="delay"
      placement="bottom"
      :target="`badge-${form}`"
    >
      <ul class="form__tooltip">
        <li
          class="form__tooltip-item"
          v-for="({id, title}) in pages"
          :key="id"
        >
          <a
            class="form__tooltip-item-link"
            :href="'/page/' + id"
          >{{ title }}</a>
        </li>
      </ul>
    </BTooltip>
  </div>
</template>

<style lang="scss" scoped>
  @import '../../../sass/variables';

  .form {
    &__badge {
      display: inline-flex;
    }

    &__tooltip {
      margin: 0;
      padding: 0;
      display: flex;
      list-style-type: none;
      align-items: flex-start;
      flex-flow: column nowrap;

      &-item {
        display: flex;
        justify-content: flex-start;

        &-link {
          color: white !important;
        }
      }
    }
  }
</style>
